import React from "react"
import { BlockUI as PrimeBlockUI } from "primereact/blockui"

/**
 * @param {import('primereact/blockui').BlockUIProps} props
 */
export default function BlockUI(props) {
  return <PrimeBlockUI {...props} />
}
